export default "__VITE_ASSET__C0chROT3__"